import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  Button,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
// import "./pdf-layer-fix.css";

import DateRangePicker from "../../../components/DateRangePicker";
import "./dataDeletion.scss";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import moment from "moment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Autocomplete from "@mui/material/Autocomplete";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Index = () => {
  const dispatch = useDispatch();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [input, setInput] = useState("");
  const [file, setFile] = useState("");
  const [listData, setListData] = useState([]);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  const data = useSelector((state) => state?.admin?.deletedData);

  useEffect(() => {
    dispatch(
      acts.getDeletedData({
        formattedStartDate: "",
        formattedEndDate: "",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (data && data.length > 0) {
      setListData([...data]);
    } else {
      setListData([]);
    }

    if (data && data?.message && data?.next === false) {
      setMessage(data.message);
      setErr(true);
    }
  }, [data]);

  const handleChange = (event, data) => {
    if (!data) {
      setInput("");
      setFile("");
    } else {
      setFile(data?.url);
      setInput(data?.name);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const filterByDate = (startDate, endDate) => {
    const formattedStartDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : "";
    const formattedEndDate = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    dispatch(
      acts.getDeletedData({
        formattedStartDate,
        formattedEndDate,
      })
    );
  };

  const downloadPdf = (file) => {
    const link = document.createElement("a");
    link.href = file;
    link.target = "_blank";
    link.click();
  };

  const clear = () => {
    dispatch(
      acts.getDeletedData({
        formattedStartDate: "",
        formattedEndDate: "",
      })
    );
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>

          <Grid item className="visualization-conatiner data-deletion-wrap">
            <AdministratorHeader text="Data Deletion Reports" />

            <Grid container className="input-wrap">
              <Grid item md={4}>
                <DateRangePicker filterByDate={filterByDate} clear={clear} />
              </Grid>

              <Grid item md={6} className="selectDataReport-wrap">
                <FormControl className="selectDataReport">
                  <InputLabel className="select-label">Select File</InputLabel>
                  <Autocomplete
                    options={listData.map((list) => ({
                      name: list?.report_name,
                      url: list?.url,
                    }))}
                    getOptionLabel={(option) => option?.name}
                    inputValue={input}
                    onChange={handleChange}
                    onInputChange={(event, newInputValue) =>
                      setInput(newInputValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder="Select File"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid className="download-pdf" item md={1}>
                <Button
                  onClick={() => downloadPdf(file)}
                  size="medium"
                  className="download-pdf_-btn"
                  startIcon={<FileDownloadIcon />}
                  disabled={!file}
                >
                  Download
                </Button>
              </Grid>
            </Grid>

            {err && (
              <CustomizedSnackbars
                severity="error"
                state={err}
                text={message}
                handleClose={() => setErr(false)}
              />
            )}

            <Box className="data-deletion-document">
              <Box className="pagination">
                <div className="p-sticky">
                  <label className="paginationLabel">Page {pageNumber}</label>
                  <IconButton
                    onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
                    disabled={pageNumber === 1}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      setPageNumber((p) => Math.min(p + 1, numPages))
                    }
                    disabled={pageNumber === numPages}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </div>
              </Box>

              <Document file={file || ""} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Index;
